import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled, useMediaQuery, useTheme } from '@mui/system';
import toPlayMoney from '@helpers/toPlayMoney';
import toRealMoney from '@helpers/toRealMoney';
const Wrapper = styled('div') `
  display: inline-flex;
  flex-direction: ${({ isStacked }) => (isStacked ? 'column' : 'row')};
  align-items: center;
  margin-bottom: 2px;
  gap: ${({ isStacked }) => (isStacked ? '4px' : '2px')};

  & .bundle-image {
    display: inline-flex;
    margin-right: ${({ isStacked }) => (isStacked ? '0' : '5px')};
  }

  & .bundle-combination {
    margin: ${({ isInResponsiveStyling }) => (isInResponsiveStyling ? 0 : '0 5px')};
    ${({ isInResponsiveStyling }) => (isInResponsiveStyling ? {} : { color: '#85898D' })}
  }

  & .bundle-amount {
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
  }

  & img {
    width: 18px;
    height: 18px;
    margin-right: -3px;
  }
`;
const DollarSymbol = styled('span') `
  margin-right: 0 !important;
`;
// normalize prizingSummary
const normalizePrizingSummary = (prizingSummary) => {
    if ('coinAmount' in prizingSummary) {
        return {
            cashAmount: prizingSummary.cashAmount,
            coinAmount: prizingSummary.coinAmount,
            productAmount: prizingSummary.productAmount,
        };
    }
    return {
        cashAmount: prizingSummary.cash_amount,
        coinAmount: prizingSummary.coin_amount,
        productAmount: prizingSummary.product_amount,
    };
};
const PrizeBundle = ({ haveResponsive, showCompactVersion, withDollarSymbol = true, className, applyStacking = false, prizingSummary, }) => {
    const { cashAmount, coinAmount, productAmount } = normalizePrizingSummary(prizingSummary);
    const isCompactScreen = useMediaQuery('@media (max-width:1200px)');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    // Only use on mobile
    const isStacked = isMobile && applyStacking;
    const isInResponsiveStyling = showCompactVersion || (!!haveResponsive && isCompactScreen);
    if (cashAmount === 0 && coinAmount === 0 && productAmount === null) {
        return _jsx("span", { "data-testid": "no-prize-bundle", children: "-" });
    }
    const hasUSD = cashAmount > 0 || productAmount !== null;
    const hasCoins = coinAmount > 0;
    const totalUsdAmount = cashAmount + (productAmount !== null && productAmount !== void 0 ? productAmount : 0);
    // Mobile layout (icons on top, value below)
    if (isStacked) {
        return (_jsxs(Wrapper, { isInResponsiveStyling: isInResponsiveStyling, isStacked: true, className: className, "data-ignore": true, "data-testid": "prize-bundle", children: [_jsxs("div", { className: "bundle-image", children: [hasCoins && (_jsx("img", { src: "https://static.repeat.gg/rewards/coin.png", alt: "coin", "data-testid": "coin-amount-icon" })), productAmount !== null && (_jsx("img", { src: "https://static.repeat.gg/rewards/product.png", alt: "product", "data-testid": "product-amount-icon" })), cashAmount > 0 && (_jsx("img", { src: "https://static.repeat.gg/rewards/dollar.png", alt: "cash", "data-testid": "cash-amount-icon" }))] }), _jsxs("div", { className: "bundle-amount", children: [hasUSD && hasCoins && (_jsxs(_Fragment, { children: [_jsx(DollarSymbol, { "data-testid": "dollarSymbol", children: "$" }), toRealMoney(totalUsdAmount), "+"] })), hasUSD && !hasCoins && (_jsxs(_Fragment, { children: [_jsx(DollarSymbol, { "data-testid": "dollarSymbol", children: "$" }), toRealMoney(totalUsdAmount)] })), !hasUSD && hasCoins && coinAmount.toLocaleString()] })] }));
    }
    // Desktop/non-stacked layout
    return (_jsxs(Wrapper, { isInResponsiveStyling: isInResponsiveStyling, isStacked: false, className: className, "data-ignore": true, "data-testid": "prize-bundle", children: [hasUSD && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "bundle-image", children: [coinAmount > 0 && isInResponsiveStyling && (_jsx("img", { src: "https://static.repeat.gg/rewards/coin.png", alt: "coin", "data-testid": "coin-amount-icon" })), productAmount !== null && (_jsx("img", { src: "https://static.repeat.gg/rewards/product.png", alt: "product", "data-testid": "product-amount-icon" })), cashAmount > 0 && (_jsx("img", { src: "https://static.repeat.gg/rewards/dollar.png", alt: "cash", "data-testid": "cash-amount-icon" }))] }), _jsxs("div", { className: "bundle-amount", "data-testid": "total-cash-amount", children: [withDollarSymbol && _jsx(DollarSymbol, { "data-testid": "dollarSymbol", children: "$" }), withDollarSymbol ? toRealMoney(totalUsdAmount) : `$${toRealMoney(totalUsdAmount)}`] })] })), hasUSD && coinAmount > 0 && _jsx("div", { className: "bundle-combination", children: "+" }), coinAmount > 0 && (totalUsdAmount === 0 || !isInResponsiveStyling) && (_jsxs(_Fragment, { children: [_jsx("div", { className: "bundle-image", children: _jsx("img", { src: "https://static.repeat.gg/rewards/coin.png", alt: "coin", "data-testid": "coin-amount-icon" }) }), _jsx("div", { className: "bundle-amount", "data-testid": "coin-amount", children: toPlayMoney(coinAmount) })] }))] }));
};
export default PrizeBundle;
